import { Outlet } from 'react-router-dom'
import { ThemeProvider } from '../../context/ThemeContext'
import { ErrorBoundary } from '../ui/ErrorBoundary'
import { ErrorToast } from '../features/ErrorToast'
import { SkipLink } from './SkipLink'

export function AppShell() {
  return (
    <ThemeProvider>
      <ErrorBoundary>
        <SkipLink />
        <div className="min-h-screen bg-background text-foreground">
          <main id="main-content" className="flex-1">
            <Outlet />
          </main>
          <ErrorToast />
        </div>
      </ErrorBoundary>
    </ThemeProvider>
  )
}
